/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import * as Types from '../../../types/schema.generated';

import gql from 'graphql-tag';
import { MemberManagementFormFragmentDoc } from '../../../components/organisms/MemberManagementForm/MemberManagemenetForm.generated';
export type StaffRole =
  | 'BRANCH_MANAGER'
  | 'CORPORATION_ADMIN'
  | 'ENTRANCE_MANAGER'
  | 'MEMBER';

export type SettingsPageMemberManagementUpdateContentViewStaffFragment = { guid: string, name: string | null, email: string, role: Types.StaffRole };

export type SettingsPageMemberManagementUpdateContentViewQueryFragment = { planner: { id: string, email: string } | null, viewer: { staff: { guid: string } }, teams: Array<{ guid: string, name: string }> };

export const SettingsPageMemberManagementUpdateContentViewStaffFragmentDoc = gql`
    fragment SettingsPageMemberManagementUpdateContentViewStaff on Staff {
  guid
  name
  email
  role
}
    `;
export const SettingsPageMemberManagementUpdateContentViewQueryFragmentDoc = gql`
    fragment SettingsPageMemberManagementUpdateContentViewQuery on Query {
  ...MemberManagementForm
  planner {
    id
    email
  }
  viewer {
    staff {
      guid
    }
  }
}
    ${MemberManagementFormFragmentDoc}`;